import { Component } from '@angular/core';

@Component({
  selector: 'app-main-orden-carro',
  template: `<router-outlet></router-outlet>`,
})
export class MainOrdenCarroComponent {
}
